module.exports = __webpack_public_path__ + "static/img/12.b738a3bd.png";